import { render, staticRenderFns } from "./WebmailCard.vue?vue&type=template&id=47179cdc&scoped=true"
import script from "./WebmailCard.vue?vue&type=script&lang=js"
export * from "./WebmailCard.vue?vue&type=script&lang=js"
import style0 from "./WebmailCard.vue?vue&type=style&index=0&id=47179cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47179cdc",
  null
  
)

export default component.exports